import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensServicesCategory} from './citizens-services-category.model';
import * as CitizensServicesCategoryActions from './citizens-services-category.actions';

export const citizensServicesCategoriesFeatureKey = 'citizensServicesCategories';

export interface State extends EntityState<CitizensServicesCategory> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensServicesCategory> = createEntityAdapter<CitizensServicesCategory>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensServicesCategoryActions.addCitizensServicesCategory,
    (state, action) => adapter.addOne(action.citizensServicesCategory, state)
  ),
  on(CitizensServicesCategoryActions.upsertCitizensServicesCategory,
    (state, action) => adapter.upsertOne(action.citizensServicesCategory, state)
  ),
  on(CitizensServicesCategoryActions.addCitizensServicesCategorys,
    (state, action) => adapter.addMany(action.citizensServicesCategorys, state)
  ),
  on(CitizensServicesCategoryActions.upsertCitizensServicesCategorys,
    (state, action) => adapter.upsertMany(action.citizensServicesCategorys, state)
  ),
  on(CitizensServicesCategoryActions.updateCitizensServicesCategory,
    (state, action) => adapter.updateOne(action.citizensServicesCategory, state)
  ),
  on(CitizensServicesCategoryActions.updateCitizensServicesCategorys,
    (state, action) => adapter.updateMany(action.citizensServicesCategorys, state)
  ),
  on(CitizensServicesCategoryActions.deleteCitizensServicesCategory,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensServicesCategoryActions.deleteCitizensServicesCategorys,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensServicesCategoryActions.loadCitizensServicesCategorys,
    (state, action) => adapter.setAll(action.citizensServicesCategorys, state)
  ),
  on(CitizensServicesCategoryActions.clearCitizensServicesCategorys,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
